import useAttentionSignals from './useAttentionSignals';

const TEXT = {
  documents: (item) => `${item.count} employment document${item.count === 1 ? '' : 's'} missing`,
  emergency: () => 'No emergency contact on file',
  address: () => 'No home address on file',
};

/**
 * What needs this person's attention, directly under their identity.
 *
 * Self view only -- it is a to-do list, and a colleague's to-do list is both
 * none of your business and not actionable by you.
 *
 * Three rules this component exists to honour:
 *
 * 1. SILENCE WHEN CLEAR. Nothing outstanding renders nothing at all. A
 *    cleared checklist that keeps saying "all good" trains people to stop
 *    reading it, which costs us the one time it matters.
 *
 * 2. OMIT, NEVER ZERO, ON FAILURE. If a source call fails we drop that signal
 *    entirely rather than reporting it as satisfied. Saying "0 documents
 *    missing" when we could not read the documents is the same class of lie
 *    the server's not_synced/no_hr_record discriminator exists to prevent --
 *    and this one would tell someone their paperwork is complete when we have
 *    no idea whether it is.
 *
 * 3. AVAILABLE:FALSE IS NOT "NOTHING MISSING". An unsynced HR record means we
 *    do not KNOW what is on file. On launch day that is every employee.
 *
 * It composes endpoints the tabs already call, so it adds no server surface.
 */
export default function AttentionStrip({ onGoToTab, refreshKey }) {
  const { items } = useAttentionSignals(refreshKey);

  if (items.length === 0) return null;

  return (
    <section className="pf-attention" aria-label="Needs your attention">
      <ul className="pf-attention__list">
        {items.map((item) => (
          <li key={item.id} className="pf-attention__item">
            <button
              type="button"
              className="pf-attention__button"
              onClick={() => onGoToTab(item.tab)}
            >
              <span className="pf-attention__mark" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" focusable="false">
                  <path d="M12 6v7" /><path d="M12 17.5v.01" />
                </svg>
              </span>
              <span className="pf-attention__text">{TEXT[item.id](item)}</span>
              <svg className="pf-attention__go" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
                <path d="m9 6 6 6-6 6" />
              </svg>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
